import { render } from "./mobileMenuFooter.vue?vue&type=template&id=3b47015c&scoped=true"
import script from "./mobileMenuFooter.vue?vue&type=script&lang=js"
export * from "./mobileMenuFooter.vue?vue&type=script&lang=js"

import "./mobileMenuFooter.vue?vue&type=style&index=0&id=3b47015c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b47015c"]])

export default __exports__